/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';
import certificate from './images/pq_certificate.png';

const { state } = store( 'multiple-choice-quiz', {
	state: {
		//Array of { uniqueId, isCorrect } objects
		registry: [],
		get correctCount() {
            return state.registry.filter(item => item.isCorrect).length;
        },
        get totalCount() {
            return state.registry.length;
        },
		get thePercent() {
			return state.correctCount/state.totalCount;
		},
		showAnswer: false,//show--has no animation
        visibleButtonSection: false,//visible--has animation
        visibleForm: false,//visible--has animation
		isSuccessful: false,//form data successfully submitted to database
        isDisabled: false,
		disabledButton: false,
		buttonMessage: "Grade Quiz",
        downloadButtonMessage: "Download Results",
		isPerfectScore: false,
		isGoodScore: false,
		isMiddleScore: false,
		isPoorScore: false,
		message: " ",
        isOneQuestion: false,//if true, exclude elements that are not appropriate for a one-question quiz
	},
	actions: {
		//action taken by child block on init (syncToRegistry callback updates the registry when isCorrect changes)
		registerChild: () => {
            const { uniqueId, isCorrect, selectedOption } = getContext();
           	state.registry.push( { uniqueId, isCorrect, selectedOption } );
            if (state.registry.length === 1) {
                state.isOneQuestion = true;
            } else { state.isOneQuestion = false }
			console.log(state.registry);
        },
        toggleVisibleForm: () => {
            state.visibleForm = !state.visibleForm;
            if (state.downloadButtonMessage === "Download Results") {
                state.downloadButtonMessage = "Close";
            } else {
                state.downloadButtonMessage = "Download Results";
            }
            console.log('Toggle Visible Form', state.visibleForm);
        },
		showAnswer: () => {
            state.showAnswer = true; 
			state.buttonMessage = state.correctCount + " Correct";
			state.isDisabled = true;
			state.disabledButton = true;
            state.visibleButtonSection = true;

			if (state.thePercent > .99) {
				state.isPerfectScore = true;
			} else if ( (state.thePercent > .79) & (state.thePercent < 1.00) ) {
				state.isGoodScore = true;
			} else if ( (state.thePercent > .39) & (state.thePercent < .80) ) {
				state.isMiddleScore = true;
			} else if ( state.thePercent < .40) {
				state.isPoorScore = true;
			}
		},
		retakeQuiz: () => {
			window.location.reload(true);
			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			} else {
				// Fallback for browsers that don't support history.scrollRestoration
				window.onbeforeunload = function () {
					window.scrollTo(0, 0);
				}
			}
		},
        deleteFormElements: () => {
            const elements = document.querySelectorAll('element-removal');

                        elements.forEach(element => {
                            element.remove();
                        });
        },
		submit: async (event) => {
            event.preventDefault();
            const context = getContext();
            const { ref } = getElement(); // Reference to the form element

            // Start loading state
            context.loading = true;
            context.message = '';

            // Prepare the AJAX payload
            const formData = new FormData(ref);
            formData.append('action', 'save_custom_form'); // Matches the PHP hook
            formData.append('nonce', context.nonce);       // Security token from context

            // Get the registry Array from the state to use as the scores in the database
            const registryObject = JSON.stringify(state.registry);
            formData.append('scores_json', registryObject);

            // Add the Post ID
            formData.append('post_id', context.postId);
            console.log(formData);

            try {
				const context = getContext();
                const response = await fetch(context.ajaxUrl, {
                    method: 'POST',
                    body: formData,
                });

                const res = await response.json();

                if (res.success) {
                    context.message = res.data; // Success message from PHP
                    ref.reset();               // Clear the form
                    // Delete elements from form which are no longer needed
                    const elementToRemove = document.getElementById('removable-elements');
                    if (elementToRemove) {
                        elementToRemove.remove();
                    }
                    //update value of isSuccessful
                    state.isSuccessful = true;
                    console.log('Value of isSuccessful:', state.isSuccessful);
                    
                } else {
                    context.message = res.data; // Error message from PHP
                }
            } catch (err) {
                context.message = 'A network error occurred. Please try again.';
            } finally {
                context.loading = false;
            }
        },
        updateName: ( event ) => {
            const context = getContext();
            context.inputFirstName = event.target.value;
        },
        updateLastName: ( event ) => {
            const context = getContext();
            context.inputLastName = event.target.value;
        },
	},
	callbacks: {
		//this is called from the child block's wrapper using data-wp-watch="callbacks.syncToRegistry"
		//updates the registry Array which was created in the global state when the child blocks init
        syncToRegistry: () => {
            const { uniqueId, isCorrect, selectedOption } = getContext();

            // Find if this specific child is already in the registry
            const index = state.registry.findIndex( item => item.uniqueId === uniqueId );

            if ( index !== -1 ) {
                // If child exists, update its isCorrect value
                state.registry[index].isCorrect = isCorrect;
				state.registry[index].selectedOption = selectedOption;
            } else {
                // If child is not there yet, add it
                state.registry.push({ uniqueId, isCorrect, selectedOption });
            }
            console.log('Registry synced:', state.registry);
        },
        provideDownload: () => {
            console.log("certificate:", certificate);
            if (state.isSuccessful) {
                const canvas = document.getElementById("downloadCanvas");
                const ctx = canvas.getContext("2d");
                
                //Get values for the certificate
                const context = getContext();
                const userName = context.inputFirstName + " " + context.inputLastName;
                const userScore = String(state.correctCount) + "/" + String(state.totalCount) + " Correct";
                const quizName = context.nameForQuiz.replace(/&amp;/g, '&');
                const currentDate = new Date();
                const quizDate = currentDate.toLocaleDateString();

                //create new Image for the imported image file
                const image = new Image();

                // .onload ensures image is fully loaded before drawing
                image.onload = function() {
                ctx.drawImage(image, 0, 0, 500, 500); 

                ctx.fillStyle = "black";
                ctx.font = "34px 'Camber', Arial, Helvetica, sans-serif";
                ctx.textAlign = "center";
                ctx.fillText("Thanks for taking our quiz!", 250, 80, 460);
                ctx.font = "28px 'Camber', Arial, Helvetica, sans-serif";
                ctx.fillText(userName, 250, 160, 450);
                ctx.fillText(userScore, 250, 230, 450);
                ctx.font = "20px 'Camber', Arial, Helvetica, sans-serif";
                ctx.fillText(quizName, 250, 290, 450);
                ctx.fillText(quizDate, 250, 320, 450);

                downloadLink.href = canvas.toDataURL("image/png");
                    
                downloadCanvas();
                };

                //Get the imported logo file URL AFTER the onload function
                image.src = certificate;

                function downloadCanvas() {
                    const canvas = document.getElementById("downloadCanvas");
                    // Convert canvas to a data URL (PNG format)
                    const imageURL = canvas.toDataURL('image/png');
                    
                    // Create anchor element
                    const link = document.createElement('a');
                    link.href = imageURL;
                }
            }
        }
    }
} );



